export enum FormTextSelectWithInputBlock {
  Root = 'FormTextSelectWithInput',
}
